import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { NetworkObserverService } from '../../services/network';
import { map, Observable } from 'rxjs';

// TODO - Hybrid App - this is probably not a final version of this guard, added for testing

export const networkGuard = (): Observable<boolean | UrlTree> => {
  const networkObserver = inject(NetworkObserverService);
  const router = inject(Router);

  return networkObserver.connectionStatus$.pipe(
    map((status) => {
      if (status.connected) {
        return true;
      }

      return router.createUrlTree(['NoNetwork']);
    }),
  );
};
